import type { MaskRect } from '@innspel/core';

/** The attribute the host sets on what must never be part of an image (DD-39). */
export const PRIVATE_ATTRIBUTE = 'data-innspel-private';

/** The attribute the widget sets on itself, so it never ends up in the image. */
export const WIDGET_ATTRIBUTE = 'data-innspel-widget';

/**
 * An image ready for preview: a bitmap and the private fields'
 * rectangles in the image's pixels. The raw bitmap never leaves the widget — what
 * gets uploaded is the composite with the masks (K4).
 */
export interface Fangst {
  bilde: CanvasImageSource;
  width: number;
  height: number;
  /** Private fields (DD-39), all in the image's pixels. Empty for an uploaded file. */
  automasker: MaskRect[];
  /**
   * The text lines on the page in the image's pixels — what «Masker all tekst» (mask all
   * text) covers (DD-40). Omitted for an uploaded file; the whole image is pixelated instead.
   */
  tekstRekter?: MaskRect[];
  kilde: 'side' | 'fil';
}

/**
 * Capture of the page. The package has its own (`renderPage` in renderer.ts, SVG
 * foreignObject, zero dependencies — K19), and the host can swap it out for
 * e.g. html-to-image through this adapter (tech-decisions.md, «M1.5»),
 * the same pattern as `createScreenshotAdapter` in React Native.
 */
export interface ScreenshotAdapter {
  /**
   * Captures `rot` (typically `document.body`) without elements marked
   * `data-innspel-widget`. Private fields are returned as rectangles in the IMAGE'S
   * pixels, so the widget can mask them regardless of who rendered.
   */
  capture(rot: HTMLElement): Promise<Fangst>;
}
